import { render, staticRenderFns } from "./AddImsGroupDialog.vue?vue&type=template&id=c5841944&scoped=true&"
import script from "./AddImsGroupDialog.vue?vue&type=script&lang=js&"
export * from "./AddImsGroupDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5841944",
  null
  
)

export default component.exports